<samweb-loading-indicator
   fxFlexFill
   [showForAllLongRunningContextCategories]="false"
   [longRunningContextCategories]="['AGENT_DETAILS']"
   [runForever]="false"
>
   <div *ngIf="currentUser$ | async as currentUser; else noAgentSelected" fxLayout="column" fxFill>
      <ng-container
         [ngTemplateOutlet]="(isInEditMode$ | async) ? editMode : viewMode"
         [ngTemplateOutletContext]="{ cu: currentUser, em: isInEditMode }"
      ></ng-container>
   </div>
</samweb-loading-indicator>

<ng-template #titleBar let-currentUser="cu" let-isInEditMode="em">
   <div fxLayout="row">
      <div fxFlex="1 1 auto" class="user-name">{{ currentUser.displayName }}</div>
      <div>
         <button
            *ngIf="isSupervisor$ | async"
            kendoButton
            kendoTooltip
            class="toggle-button"
            [disabled]="!(canBargeIn$ | async)"
            [class.k-state-active]="isListeningToSelectedAgent$ | async"
            (click)="bargeInListen()"
            title="{{ 'user_actions.types.barge_in_listen.description' | translate }}"
         >
            <fa-icon [icon]="listenIcon" [fixedWidth]="true"></fa-icon>
         </button>
      </div>
      <div>
         <button
            *ngIf="isSupervisor$ | async"
            kendoButton
            kendoTooltip
            class="toggle-button"
            [disabled]="!(canBargeIn$ | async)"
            [class.k-state-active]="isWhisperingToSelectedAgent$ | async"
            (click)="bargeInWhisper()"
            title="{{ 'user_actions.types.barge_in_whisper.description' | translate }}"
         >
            <fa-icon [icon]="whisperIcon" [fixedWidth]="true"></fa-icon>
         </button>
      </div>
      <div>
         <button
            *ngIf="isSupervisor$ | async"
            kendoButton
            kendoTooltip
            class="toggle-button"
            [disabled]="!(canBargeIn$ | async)"
            [class.k-state-active]="isConferencingWithSelectedAgent$ | async"
            (click)="bargeInConference()"
            title="{{ 'user_actions.types.barge_in_conference.description' | translate }}"
         >
            <fa-icon [icon]="conferenceIcon" [fixedWidth]="true"></fa-icon>
         </button>
      </div>
      <div>
         <button
            *ngIf="isSupervisor$ | async"
            kendoButton
            kendoTooltip
            class="toggle-button button-spacing"
            [class.k-state-active]="isInEditMode"
            (click)="toggleEditMode()"
         >
            <fa-icon [icon]="editIcon" [fixedWidth]="true"></fa-icon>
         </button>
      </div>
   </div>
</ng-template>

<ng-template #editMode let-currentUser="cu">
   <div fxFlex="0 0 auto" fxLayout="column" class="content-container sam-margin-left sam-margin-right">
      <div fxFlex="1 1 auto" class="section-title sam-padding-bottom">
         <ng-container
            [ngTemplateOutlet]="titleBar"
            [ngTemplateOutletContext]="{ cu: currentUser, em: true }"
         ></ng-container>
      </div>
   </div>
   <div fxLayout="column" class="content">
      <div fxFlex="0 0 auto" fxLayout="column" class="content-container data-row">
         <div fxFlex="1 1 auto" class="section-title">
            {{ 'brick.brick_definitions.agent_details.status' | translate }}
         </div>
         <samweb-user-status-dropdown
            fxFlex="0 0 auto"
            [userId]="currentUser.userId"
            [disabled]="!(isAgentOnline$ | async)"
         ></samweb-user-status-dropdown>
      </div>
      <div
         *ngIf="(skillList$ | async | callingSkills)?.length > 0"
         fxFlex="0 0 auto"
         fxLayout="column"
         class="content-container data-row"
      >
         <div fxFlex="1 1 auto" class="section-title">
            {{ 'brick.brick_definitions.agent_details.calling_skills' | translate }}
         </div>
         <div fxLayout="column">
            <div
               fxFlex="0 0 auto"
               *ngFor="let skillGroup of skillList$ | async | callingSkills"
               class="sam-padding-bottom"
            >
               <samweb-skill-active-state-checkbox
                  class="sam-margin-right"
                  fxFlex="0 0 auto"
                  fxFlexAlign="center"
                  [brickInstanceId]="brickInstanceId"
                  [userId]="currentUser.userId"
                  [skillGroup]="skillGroup"
                  [disabled]="!(isAgentOnline$ | async) || !(isAgentLoggedOn$ | async)"
                  [disableLoadingAnimation]="true"
                  (activeStateChanged)="changeSkillStatus(skillGroup.skills, $event)"
               >
               </samweb-skill-active-state-checkbox>
               <samweb-skill-short-info
                  fxFlex="0 0 auto"
                  fxFlexAlign="center"
                  [skillConfiguration]="skillGroup.skillConfiguration"
                  [skills]="skillGroup.skills"
               ></samweb-skill-short-info>
            </div>
         </div>
      </div>

      <div
         *ngIf="(skillList$ | async | mailingSkills)?.length > 0"
         fxFlex="0 0 auto"
         fxLayout="column"
         class="content-container data-row"
      >
         <div fxFlex="1 1 auto" class="section-title">
            {{ 'brick.brick_definitions.agent_details.mailing_skills' | translate }}
         </div>
         <div fxLayout="column">
            <div
               fxFlex="0 0 auto"
               *ngFor="let skillGroup of skillList$ | async | mailingSkills"
               class="sam-padding-bottom"
            >
               <samweb-skill-active-state-checkbox
                  class="sam-margin-right"
                  fxFlex="0 0 auto"
                  fxFlexAlign="center"
                  [brickInstanceId]="brickInstanceId"
                  [userId]="currentUser.userId"
                  [skillGroup]="skillGroup"
                  [disabled]="!(isAgentOnline$ | async) || !(isAgentLoggedOn$ | async)"
                  [disableLoadingAnimation]="true"
                  (activeStateChanged)="changeSkillStatus(skillGroup.skills, $event)"
               >
               </samweb-skill-active-state-checkbox>
               <samweb-skill-short-info
                  fxFlex="0 0 auto"
                  fxFlexAlign="center"
                  [skillConfiguration]="skillGroup.skillConfiguration"
                  [skills]="skillGroup.skills"
               ></samweb-skill-short-info>
            </div>
         </div>
      </div>
   </div>
</ng-template>

<ng-template #viewMode let-currentUser="cu">
   <div
      fxFlex="0 0 auto"
      fxLayout="column"
      class="content-container sam-margin-left sam-margin-right sam-padding-bottom"
   >
      <div fxFlex="1 1 auto" class="section-title sam-padding-bottom">
         <div fxLayout="row">
            <div *ngIf="currentUserDebounced$ | async as currentUserDebounced">
               <samweb-avatar
                  *ngIf="showAvatar$ | async"
                  [userId]="currentUserDebounced.userId"
                  fxFlex="0 0 60px"
                  [showPresenceStatus]="false"
               ></samweb-avatar>
            </div>
            <div fxFlex="1 1 auto" class="sam-margin-left">
               <ng-container
                  [ngTemplateOutlet]="titleBar"
                  [ngTemplateOutletContext]="{ cu: currentUser, em: false }"
               ></ng-container>
               <div>
                  <samweb-agent-status [statusInfo]="currentUser.userStatus"></samweb-agent-status>
               </div>
            </div>
         </div>
      </div>
   </div>

   <div fxLayout="column" class="content">
      <div *ngIf="showCaller$ | async" class="data-row">
         <span kendoTooltip [title]="'brick.brick_definitions.agent_details.rows.peer_id' | translate">
            <fa-icon class="sam-margin-right" [icon]="callerIcon" [fixedWidth]="true"></fa-icon>
         </span>
         <div fxFlex="1 1 auto">
            {{ currentUser.peerNumber }}
         </div>
      </div>

      <div *ngIf="showGroups$ | async" class="data-row">
         <span kendoTooltip [title]="'brick.brick_definitions.agent_details.rows.groups' | translate">
            <fa-icon class="sam-margin-right" [icon]="groupIcon" [fixedWidth]="true"></fa-icon>
         </span>
         <div fxFlex="1 1 auto">
            <div fxFlex="1 1 auto" *ngIf="currentUser.memberOfGroups.length > 0; else noData">
               <samweb-group-names-for-ids
                  *ngFor="let groupId of currentUser.memberOfGroups; let isLast = last"
                  [groupId]="groupId"
                  [isLast]="isLast"
               ></samweb-group-names-for-ids>
            </div>
         </div>
      </div>

      <div *ngIf="(showSkills$ | async) && (skillList$ | async | callingSkills)?.length > 0" class="data-row">
         <fa-layers
            fxFlex="0 0 auto"
            [fixedWidth]="true"
            [title]="'brick.brick_definitions.agent_details.rows.calling_skills' | translate"
            class="sam-margin-right"
            kendoTooltip
         >
            <fa-icon [icon]="skillIcon" style="opacity: 0.4"></fa-icon>
            <fa-icon [icon]="callingIcon" transform="shrink-6 right-4 down-6"></fa-icon>
         </fa-layers>
         <div fxFlex="1 1 auto">
            <samweb-skill-short-info
               *ngFor="let skill of skillList$ | async | callingSkills"
               [skillConfiguration]="skill.skillId | skillIdToShortSkillInfo$ | async"
               [userId]="currentUser.userId"
               [visualizeLoggedOnState]="true"
            ></samweb-skill-short-info>
         </div>
      </div>

      <div *ngIf="(showSkills$ | async) && (skillList$ | async | mailingSkills)?.length > 0" class="data-row">
         <fa-layers
            fxFlex="0 0 auto"
            [fixedWidth]="true"
            [title]="'brick.brick_definitions.agent_details.rows.mailing_skills' | translate"
            class="sam-margin-right"
            kendoTooltip
         >
            <fa-icon [icon]="skillIcon" style="opacity: 0.4"></fa-icon>
            <fa-icon [icon]="mailingIcon" transform="shrink-6 right-4 down-6"></fa-icon>
         </fa-layers>
         <div fxFlex="1 1 auto">
            <samweb-skill-short-info
               *ngFor="let skill of skillList$ | async | mailingSkills"
               [skillConfiguration]="skill.skillId | skillIdToShortSkillInfo$ | async"
               [userId]="currentUser.userId"
               [visualizeLoggedOnState]="true"
            ></samweb-skill-short-info>
         </div>
      </div>

      <div *ngIf="showCallHistory$ | async" class="data-row">
         <span
            kendoTooltip
            [title]="'brick.brick_definitions.agent_details.rows.call_history' | translate"
            class="history-icon"
         >
            <fa-icon fxFlex="0 0 auto" class="sam-margin-right" [icon]="callHistoryIcon" [fixedWidth]="true"></fa-icon>
         </span>
         <div
            fxFlex="1 1 auto"
            *ngIf="(callHistory$ | async)?.length > 0; else noData"
            class="calculated-width sam-margin-left"
         >
            <samweb-call-history-for-agent [callHistory]="callHistory$ | async"></samweb-call-history-for-agent>
         </div>
      </div>
   </div>
</ng-template>

<ng-template #noData>
   <div fxFlex="1 1 auto">-</div>
</ng-template>

<ng-template #noAgentSelected>
   <samweb-no-value-selected-info
      [textTranslationKey]="'brick.brick_definitions.agent_details.no_agent_selected'"
      [icon]="noAgentSelectedIcon"
   >
   </samweb-no-value-selected-info>
</ng-template>
